<template>
  <div id="home">
    <div id="hello-screen">
      <HelloBackground />
      <Greeter :content="websiteMainContent['hello-screen']"/>
      <ClickMe />
    </div>

    <div id="about" class="screen">
      <Title :content="websiteMainContent.about.title" color="#bac312"/>
      <p v-html="websiteMainContent.about.content"></p>
    </div>

    <div id="offer" class="screen">
      <Title :content="websiteMainContent.offer.title" />
      <p v-html="websiteMainContent.offer.content"></p>
      <CategoryGrid :offerData="offerData"/>
    </div>

    <div id="services" class="screen">
      <ServicesBG />
      <Title :content="websiteMainContent.services.title" color="white"/>
      <ServicesList :services-list="servicesList"/>
      <p style="color: white" v-html="websiteMainContent.services.content"></p>
    </div>

    <div id="delivery" class="screen">
      <Title :content="websiteMainContent.delivery.title" color="#bac312"/>
      <p v-html="websiteMainContent.delivery.content"></p>
    </div>

    <ContactScreenContainer :contact-data="contactData"/>

    <div id="partners" class="screen">
      <PartnersGrid :pArray="partnersList"/>
    </div>

    <div id="footer" class="screen">
      <span>Copyright &copy; 2019 Dach-Bud GRUDZIĄDZ</span>
    </div>
  </div>
</template>

<script>
import HelloBackground from '@/components/HelloScreen/HelloBackground.vue';
import Greeter from '@/components/HelloScreen/Greeter.vue';
import ClickMe from '@/components/HelloScreen/ClickMe.vue';
import Title from '@/components/Title.vue';
import CategoryGrid from '@/components/OfferScreen/CategoryGrid.vue';
import ServicesBG from '@/components/ServicesScreen/ServicesBG.vue';
import ServicesList from '@/components/ServicesScreen/ServicesList.vue';
import PartnersGrid from '@/components/PartnersScreen/PartnersGrid.vue';
import ContactScreenContainer from '@/components/ContactScreen/ContactScreenContainer.vue';

import axios from 'axios';

const API = require('../api.json').api_v1;

export default {
  name: 'home',
  components: {
    ContactScreenContainer,
    PartnersGrid,
    ServicesList,
    ServicesBG,
    CategoryGrid,
    Title,
    ClickMe,
    HelloBackground,
    Greeter,
  },
  data() {
    return {
      menuContent: [
        { id: 1, tag: 'about', content: 'O FIRMIE' },
        { id: 2, tag: 'offer', content: 'OFERTA' },
        { id: 3, tag: 'services', content: 'USŁUGI' },
        { id: 4, tag: 'delivery', content: 'DOSTAWA' },
        { id: 5, tag: 'contact', content: 'KONTAKT' },
        { id: 6, tag: 'partners', content: 'PARTNERZY' },
      ],
      offerData: [{ id: null, image: '', title: '' }],
      servicesList: [{ id: null, content: '' }],
      contactData: {
        id: null,
        address_1: '',
        address_2: '',
        town_and_code: '',
        info: '',
        fax: '',
        phone_num: '',
        email: '',
        opening_hours: '',
      },
      partnersList: [{ id: null, name: '', image: '' }],
      websiteMainContent: {
        'hello-screen': { title: '', content: '' },
        about: { title: '', content: '' },
        offer: { title: '', content: '' },
        services: { title: '', content: '' },
        delivery: { title: '', content: '' },
      },
    };
  },
  methods: {
    async getCategories() {
      let response = await axios.get(`${API}/categories`);
      response = response.data.data;
      const result = [];

      for (let i = 0; i < response.length; i++) {
        result[i] = {
          id: response[i].id,
          title: response[i].name,
          image: `${API}/categories/images/${response[i].image}`,
        };
      }
      return result;
    },
    async getFromAPI(query) {
      const result = await axios.get(`${API}/${query}`);
      return result.data.data;
    },
  },
  mounted() { window.scrollTo(0, 0); },
  async created() {
    this.websiteMainContent = await this.getFromAPI('content?s=all');
    this.servicesList = await this.getFromAPI('services');
    this.offerData = await this.getCategories();
    this.contactData = await this.getFromAPI('contact');
    this.partnersList = await this.getFromAPI('partners');
  },
};
</script>

<style scoped lang="scss">
  #hello-screen { height: 100vh }
  #about { background-color: white; }
  #offer { background-color: #e6e6e6; }
  #delivery { background-color: white; }
  #contact { background-color: #414141 }
  #partners { background-color: white }
</style>
